var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, action, computed } from 'mobx';
import { TempSaleTicket } from './TempSaleTicket';
/*import {imprimeTicket, printTicket} from '../Modulos/ticket-print/TicketPrint'*/
import { api } from 'helpers/Api';
import { getIndexForMapeo, TempSalePacket } from './TempSalePacket';
import { TypeTicket } from '../Detail/DetailRoutes';
import { lengths } from '../../helpers/Utils';
import CollaboratorStretch from '../CollaboratorStretches/CollaboratorStretch';
export default class TempTicketStore {
    constructor(store) {
        this._busy = { busy: false };
        this.printerError = '';
        this.init = () => {
            // console.log('TempTicketStore - init')
            this.printerError = '';
            this.tempSaleTicket = new TempSaleTicket(this.store);
            this.tempSalePacket = new TempSalePacket(this.store);
        };
        this.setTypeTicket = (value) => {
            this.typeTicketSelected = value;
        };
        this.sendTicket = (ticket) => {
            // this.setBusy(true)
            return api
                .post('ticketsv3', ticket)
                .then((value) => {
                console.log('sendTicket - then');
                // this.setBusy(false)
                return value;
            })
                .catch((error) => {
                console.log('sendTicket - catch - error: ', error.message);
                // this.setBusy(false)
                throw new Error(error.message);
            });
        };
        this.sendPaymentlink = (ticket) => {
            console.log('sendPaymentlink - ticket: ', ticket);
            return api
                .post('paymentlinks', ticket)
                .then(value => {
                return value;
            })
                .catch(error => {
                throw error;
            });
        };
        this.sendCollaboratorTicket = (item) => {
            return api.post('collaboratorTickets', item);
        };
        // precios para servicio de paquete a 0
        this.linesToZero = (lines) => {
            return lines.map((line) => {
                return Object.assign(Object.assign({}, line.toJSON()), { price: 0, taxBase: 0, taxAmount: 0, total: 0 });
            });
        };
        this.sendPacket = (packetTicket) => {
            console.log('TempTicketStore - sendPacket - packetTicket: ', packetTicket);
            // generamos los tickes de los servicios del paquete
            const tickets = packetTicket.packet.stretches.map((stretch) => {
                var _a, _b, _c, _d, _e;
                let datebook = this.tempSalePacket.datesSelected[stretch.id];
                let hourSelected;
                if (stretch.tramoHora) {
                    hourSelected = this.tempSalePacket.hoursSelected[stretch.id];
                    datebook.setHours(hourSelected.hours, hourSelected.minutes, 0, 0);
                }
                const idavuelta = this.tempSalePacket.packet.idaVueltaSelected[stretch.id] || false;
                console.log(`la fecha para el servicio ${stretch.name} es: ${datebook.toISOString()}`);
                // fecha NTZ
                const datebookNTZ = new Date(Date.UTC(datebook.getFullYear(), datebook.getMonth(), datebook.getDate(), datebook.getHours(), datebook.getMinutes(), 0, 0));
                const values = {
                    numero: this.generateTicketNumber(stretch.operationLine.qrTicket, TypeTicket.Stretch),
                    datebook,
                    datebookNTZ,
                    hours: hourSelected ? hourSelected.hours : null,
                    minutes: hourSelected ? hourSelected.minutes : null,
                    datecheck: packetTicket.datecheck,
                    user_id: packetTicket.user.id,
                    username: packetTicket.username,
                    discount: 0,
                    discountReason: packetTicket.discountReason,
                    typeDiscount: packetTicket.typeDiscount,
                    totalDiscount: 0,
                    netAmount: 0,
                    taxAmount: 0,
                    taxName: packetTicket.packet.tax.name,
                    total: 0,
                    origin: stretch.origin,
                    destination: stretch.destination,
                    terminal: packetTicket.terminal,
                    daterefund: null,
                    userRefund: null,
                    operationLine_id: stretch.operationLine.id,
                    operationLine: stretch.operationLine,
                    operationLineName: stretch.operationLine.name,
                    businessUnitName: stretch.operationLine.businessUnit.name,
                    receiptLayout_id: stretch.receiptLayout_id,
                    tin: stretch.operationLine.businessUnit.tin,
                    stretch_id: stretch.id,
                    stretchName: stretch.name,
                    datevalited: null,
                    codeDiscount: packetTicket.codeDiscount,
                    vuelta: idavuelta,
                    printPrice: stretch.printPrice,
                    numberScanned: 0,
                    numberPrinted: 1,
                    hoponHopoff: stretch.hoponHopoff,
                    tramoHora: stretch.tramoHora,
                    timeExpiration: stretch.timeExpiration,
                    timeAdvance: stretch.timeAdvance,
                    timeDelay: stretch.timeDelay,
                    timeUse: stretch.timeUse,
                    payments: [],
                    stretch,
                    tramoHoraVuelta: stretch.tramoHoraVuelta,
                    horasVuelta: stretch.horasVuelta,
                    aditionalInfo: stretch.aditionalInfo,
                    lines: this.linesToZero(packetTicket.lines),
                    extraLines: [],
                    money: packetTicket.packet.primaryMoney.alphabeticCode,
                    contact: null,
                    // el afiliado lo gestionamos en el ticket del servicio propio
                    afiliateName: (_a = packetTicket.afiliate) === null || _a === void 0 ? void 0 : _a.name,
                    afiliateCommission: (_b = packetTicket.afiliate) === null || _b === void 0 ? void 0 : _b.commission,
                    afiliate_id: (_c = packetTicket.afiliate) === null || _c === void 0 ? void 0 : _c.id,
                    typeCommission: (_d = packetTicket.afiliate) === null || _d === void 0 ? void 0 : _d.typeCommission,
                    afiliateEmail: (_e = packetTicket.afiliate) === null || _e === void 0 ? void 0 : _e.email,
                };
                return values;
            });
            packetTicket.tickets = tickets;
            const collaboratorTickets = packetTicket.packet.collaboratorStretches.map((collaboratorStretch) => {
                // pongo el día seleccionado para el servicio en colaboración
                const datebook = this.tempSalePacket.datesSelected[getIndexForMapeo(collaboratorStretch)];
                let hourSelected;
                if (collaboratorStretch.tramoHora) {
                    // tiene hora de uso
                    hourSelected =
                        this.tempSalePacket.hoursSelected[getIndexForMapeo(collaboratorStretch)];
                    if (!hourSelected) {
                        this.store.UI.newError('UPPs, error code 700');
                        return null;
                    }
                    datebook.setHours(hourSelected.hours, hourSelected.minutes, 0, 0);
                }
                const idavuelta = this.tempSalePacket.packet.idaVueltaSelectedCollaborator[getIndexForMapeo(collaboratorStretch)] || false;
                console.log(`la fecha para el servicio ${collaboratorStretch.name} es: ${datebook.toISOString()}`);
                console.log(`el tipo de servicio es: ${idavuelta ? '2 usos' : '1 uso'}`);
                // fecha NTZ
                const datebookNTZ = new Date(Date.UTC(datebook.getFullYear(), datebook.getMonth(), datebook.getDate(), datebook.getHours(), datebook.getMinutes(), 0, 0));
                const values = {
                    client_id: packetTicket.client_id,
                    collaboratorName: packetTicket.collaboratorName,
                    operatorName: collaboratorStretch.operatorName,
                    operator_id: collaboratorStretch.operator_id,
                    numero: this.generateTicketNumber(collaboratorStretch.operationLine.qrTicket, TypeTicket.CollaboratorStretch),
                    datebook,
                    datebookNTZ,
                    hours: hourSelected ? hourSelected.hours : null,
                    minutes: hourSelected ? hourSelected.minutes : null,
                    datecheck: packetTicket.datecheck,
                    user_id: packetTicket.user.id,
                    username: packetTicket.username,
                    discount: 0,
                    discountReason: packetTicket.discountReason,
                    typeDiscount: packetTicket.typeDiscount,
                    totalDiscount: 0,
                    netAmount: 0,
                    taxAmount: 0,
                    taxName: packetTicket.packet.tax.name,
                    total: 0,
                    origin: collaboratorStretch.origin,
                    destination: collaboratorStretch.destination,
                    terminal: packetTicket.terminal,
                    daterefund: null,
                    userRefund: null,
                    operationLine_id: collaboratorStretch.operationLine.id,
                    operationLine: collaboratorStretch.operationLine,
                    operationLineName: collaboratorStretch.operationLine.name,
                    businessUnitName: collaboratorStretch.operationLine.businessUnit.name,
                    receiptLayout_id: collaboratorStretch.receiptLayout_id,
                    tin: collaboratorStretch.operationLine.businessUnit.tin,
                    stretch_id: collaboratorStretch.id,
                    stretchName: collaboratorStretch.name,
                    datevalited: null,
                    codeDiscount: null,
                    vuelta: idavuelta,
                    printPrice: collaboratorStretch.printPrice,
                    numberScanned: 0,
                    numberPrinted: 1,
                    hoponHopoff: collaboratorStretch.hoponHopoff,
                    tramoHora: collaboratorStretch.tramoHora,
                    timeExpiration: collaboratorStretch.timeExpiration,
                    timeAdvance: collaboratorStretch.timeAdvance,
                    timeDelay: collaboratorStretch.timeDelay,
                    timeUse: collaboratorStretch.timeUse,
                    payments: [],
                    stretch: collaboratorStretch,
                    tramoHoraVuelta: collaboratorStretch.tramoHoraVuelta,
                    horasVuelta: collaboratorStretch.horasVuelta,
                    aditionalInfo: collaboratorStretch.aditionalInfo,
                    lines: this.linesToZero(packetTicket.lines),
                    extraLines: [],
                    money: packetTicket.packet.primaryMoney.alphabeticCode,
                    contact: null,
                    // afiliado no vamos a gestionarlo en el ticket del servicio en colaboración
                    afiliateName: null,
                    afiliateCommission: null,
                    afiliate_id: null,
                    typeCommission: null,
                    afiliateEmail: null,
                };
                return values;
            });
            packetTicket.collaboratorTickets = collaboratorTickets;
            console.log('TempTicketStore - sendPacket - packetTicket: ', packetTicket);
            return api.post('packetTickets', packetTicket);
        };
        this.sendPaymentLinkEmails = (data) => __awaiter(this, void 0, void 0, function* () {
            return api.get('paymentlinks/emails', data);
        });
        this.sendEmails = (data) => __awaiter(this, void 0, void 0, function* () {
            return api.post('tickets/emails', data);
            const emails = `reservas@ticando.net,${data.ticket.contact.email ? data.ticket.contact.email : ''}${data.emails ? ',' + data.emails : ''}`;
            console.log('emails: ', emails);
            return api.get(`contentEmail?numero=${data.ticket.numero}&clientName=${data.clientName}&action=book&isEvent=${data.type === 'event'}&emails=${data.emails}&language=es`);
        });
        this.okDataContact = (contact) => {
            return !(!contact || !contact.name || !contact.surname || !contact.email || !contact.telephone);
        };
        this.generateTicketNumber = (qrTicket, typeTicket) => {
            console.log('generateTicketNumber - typeTicket: ', typeTicket);
            const length = lengths[typeTicket];
            if (!length) {
                throw new Error('typeTicket no valido');
            }
            // const qrTicket: string = this.tempSaleTicket.qrTicket
            // console.log('qrTicket', qrTicket)
            const part2 = this.randomString(length - 6, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ');
            return qrTicket.concat(part2);
        };
        this.randomString = (length, chars) => {
            let _chars = chars;
            if (!chars) {
                _chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            }
            let result = '';
            for (let i = length; i > 0; --i)
                result += _chars[Math.floor(Math.random() * _chars.length)];
            return result;
        };
        this.store = store;
        this.init();
    }
    /* sendTicketsNotSend = async () => {
       try {
         this.setBusy({busy: true})
         const ticketsNotSend: Ticket[] =
           await this.store.cashDeskTicketStore.getTicketsNotSend()
         this.setBusy({busy: false})
         // console.log('TempTicketStore - sendTicktesNotSend - ticketNotSend.length', ticketsNotSend.length)
         if (ticketsNotSend.length > 0) {
           this.store.cashDeskTicketStore
             .sendTickets(ticketsNotSend)
             .then((response) => {
               this.store.cashDeskTicketStore.cambiaTicketsNotSendToSend(response)
             })
             .catch((error) => {
               console.log(
                 'TempTicketStore - sendTicktesNotSend - catch - error:',
                 error
               )
             })
         }
       } catch (error) {
         console.log(
           'TempTicketStore - sendTicktesNotSend - error ticketNotSend',
           error
         )
       }
     }*/
    setBusy(busy) {
        this._busy = busy;
    }
    get busy() {
        return this._busy.busy;
    }
    print() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                /*await imprimeTicket(this.tempSaleTicket)*/
            }
            catch (e) {
                this.onRejected(e);
            }
            /*imprimeTicket(this.tempSaleTicket)
              .then(value => {
                console.log('\'TempTicketStore - print - imprimeticket')
              })
              .catch (e =>  {
                this.onRejected(e)
              })*/
        });
    }
    createSale() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('TempTicketStore - createSale');
            // this.setBusy({busy: true})
            let temp, qrTicket;
            if (this.typeTicketSelected === TypeTicket.Stretch ||
                this.typeTicketSelected === TypeTicket.CollaboratorStretch) {
                temp = this.tempSaleTicket;
            }
            else if (this.typeTicketSelected === TypeTicket.Packet) {
                temp = this.tempSalePacket;
            }
            else {
                return this.store.UI.newError('UPSS, parece que hay un error');
            }
            if (temp.lines.length <= 0) {
                console.log('TempTicketStore - createSale - temp.lines.length: ', temp.lines.length);
                return;
            }
            qrTicket =
                this.typeTicketSelected === TypeTicket.Packet
                    ? this.tempSalePacket.packet.operationLine.qrTicket
                    : this.tempSaleTicket.stretch.operationLine.qrTicket;
            const ticketNumber = this.generateTicketNumber(qrTicket, this.typeTicketSelected);
            console.log(ticketNumber);
            temp.setNumero(ticketNumber);
            // Pongo fechas
            const datecheck = new Date();
            // si no he puesto datebook es porque es para el día asi que pongo la de check y así son la misma fecha
            const dateBook = temp.datebook ? temp.datebook : new Date(datecheck);
            console.log('TempTicketStore - createTicket - this.temSaleTicket.datebook: ', temp.datebook);
            temp.setDatecheck(datecheck);
            if (this.typeTicketSelected === TypeTicket.Stretch ||
                this.typeTicketSelected === TypeTicket.CollaboratorStretch) {
                temp.setDatebook(dateBook);
                if (temp.stretch.tramoHora) {
                    dateBook.setHours(temp.timeIda.hours);
                    dateBook.setMinutes(temp.timeIda.minutes);
                    dateBook.setSeconds(0, 0);
                }
                if (temp.valitedNow) {
                    // console.log('TempTicketStore - createTicket - if - valitedNow: ', temp.valitedNow)
                    temp.setDatevalited(datecheck);
                }
                else {
                    // console.log('TempTicketStore - createTicket - else-  valitedNow: ', temp.valitedNow)
                    temp.setDatevalited(null);
                }
            }
            console.log('antes de enviar ticket');
            // Envio ticket
            const toSend = temp.toJSON();
            const store = this.store;
            const stretch = toSend.stretch;
            // elimino dato no necesario
            delete toSend.stretch;
            // console.log('this.tempSaleTicket.client_id: ', this.tempSaleTicket.client_id)
            if (this.tempSaleTicket.stretch instanceof CollaboratorStretch) {
                // ticket en colaboracion
                console.log('enviando ticket en colaboración');
                let ticketCollaborator;
                try {
                    ticketCollaborator = yield this.sendCollaboratorTicket(toSend);
                    ticketCollaborator.stretch = stretch;
                    // cambio tipo para payments y lines si es JSON
                    if (typeof ticketCollaborator.payments === 'string') {
                        ticketCollaborator.payments = JSON.parse(ticketCollaborator.payments);
                    }
                    if (typeof ticketCollaborator.lines === 'string') {
                        ticketCollaborator.lines = JSON.parse(ticketCollaborator.lines);
                    }
                    const data = {
                        clientName: this.tempSaleTicket.user.client,
                        ticket: ticketCollaborator,
                    };
                    // this.sendEmails(data)
                    temp.reset();
                    return ticketCollaborator;
                }
                catch (e) {
                    console.log('error: ', e);
                    throw e;
                }
            }
            else if (temp instanceof TempSalePacket) {
                // paquete
                console.log('temp instanceof TempSalePacket');
                try {
                    const result = yield this.sendPacket(temp);
                    console.log('createSale - result: ', result);
                    if (result.code === 200) {
                        // await store.cashDeskTicketStore.addPacketTicketToCashDesk(result.packetTicket)
                        // imprimo ticket
                        // const packetPrint = new PacketticketPrintDetail(temp.toJSON())
                        // packetPrint.toPrint(temp.packet.headboard)
                    }
                    else {
                        //
                    }
                }
                catch (e) {
                    // se ha producido un error
                    throw new Error(e.message);
                }
            }
            else if (temp instanceof TempSaleTicket) {
                // ticket
                console.log('temp instanceof TempSaleTicket');
                yield this.createTicket(false);
            }
            else {
                console.log('TempTicketStore - createSale - else - toSend: ', toSend);
                store.UI.newError('Uppss ....');
            }
        });
    }
    createTicket(isPaymentlink) {
        return __awaiter(this, void 0, void 0, function* () {
            // pongo a busy
            this.setBusy({ busy: true });
            if (!(this.tempSaleTicket.getLines().length > 0)) {
                this.setBusy({ busy: false });
                return null;
            }
            // genero el número de ticket
            // createTicket es para ticket normal
            const ticketNumber = this.generateTicketNumber(this.tempSaleTicket.operationLine.qrTicket, TypeTicket.Stretch);
            this.tempSaleTicket.setNumero(ticketNumber);
            // Pongo fechas
            const datecheck = new Date();
            // si no he puesto datebook es porque es para el día asi que pongo la de check y así son la misma fecha
            const dateBook = this.tempSaleTicket.datebook
                ? this.tempSaleTicket.datebook
                : new Date(datecheck);
            // si es tramoHora pongo hora y minutos seleccionados, y segundos y ms a 0
            if (this.tempSaleTicket.stretch.tramoHora) {
                // dateBook.setHours(this.tempSaleTicket.timeIda.hours)
                // dateBook.setMinutes(this.tempSaleTicket.timeIda.minutes)
                // dateBook.setSeconds(0,0)
            }
            console.log('datecheck: ', datecheck);
            console.log('dateBook: ', dateBook);
            this.tempSaleTicket.setDatecheck(datecheck);
            // this.tempSaleTicket.setDatebook(dateBook)
            // si lo vendo validado pongo fecha de validación, caso contrario a null
            if (this.tempSaleTicket.valitedNow) {
                // console.log('TempTicketStore - createTicket - if - valitedNow: ', this.tempSaleTicket.valitedNow)
                this.tempSaleTicket.setDatevalited(datecheck);
            }
            else {
                // console.log('TempTicketStore - createTicket - else-  valitedNow: ', this.tempSaleTicket.valitedNow)
                this.tempSaleTicket.setDatevalited(null);
            }
            console.log('antes de enviar ticket');
            // ticket temporal
            const tempTicket = this.tempSaleTicket;
            const ticketToSend = tempTicket.toJSON();
            console.log('ticketToSend: ', ticketToSend);
            /*const _data = {
              clientName: this.tempSaleTicket.user.client,
              ticket: ticketToSend
            }
            this.sendEmails(_data)*/
            // return null
            let response;
            try {
                // console.log('entro en try')
                const store = this.store;
                // const ticket: Ticket = await this.sendTicket(tempTicket)
                console.log('isPaymentlink: ', isPaymentlink);
                if (isPaymentlink) {
                    // si no tiene datos de contacto no seguimos
                    if (!this.okDataContact(tempTicket.dataContact)) {
                        this.setBusy({ busy: false });
                        this.store.UI.newError('Faltan datos de contacto');
                        return {
                            code: 404
                        };
                    }
                    // agrego número de carrito
                    const additional = Object.assign(Object.assign({}, tempTicket.additional), { tokenticket: this.randomString(20, null) });
                    tempTicket.setAdditional(additional);
                    console.log('ticket antes de sentPaymentlink: ', tempTicket);
                    response = yield this.sendPaymentlink(tempTicket);
                }
                else {
                    response = yield this.sendTicket(tempTicket);
                }
                // console.log('TempTicketStore . create - response: ', response)
                if (response.code !== 200) {
                    // this.store.UI.newError(response.message)
                    throw new Error(response.message);
                    // return
                }
                const ticket = response.payload;
                // console.log('response.ticket: ', ticket)
                yield store.users.addCaja(ticket.id, ticket.total, ticket.numero);
                yield store.cashDeskTicketStore.addTicket(ticket);
                // envío al servidor tickets no enviados
                /*this.sendTicketsNotSend()
                  .then(value => {
                    console.log('TempTicketStore - createTicket - sentTicketsNotSend - then')
                  })
                  .catch(reason => {
                    console.log('TempTicketStore - createTicket - sentTicketsNotSend - catch')
                  })*/
            }
            catch (error) {
                console.log('TempTicketStore - createTicket - catch - error.name: ', error);
                console.log('TempTicketStore - createTicket - catch - error.message: ', error.message);
                const store = this.store;
                /*await store.users.addCaja(-1, tempTicket.total, tempTicket.getNumero())
                await store.cashDeskTicketStore.addTicket(tempTicket)*/
                this.store.UI.newError('Se ha producido un error: ' + error.message);
                this.setBusy({ busy: false });
                throw new Error(error);
                return {
                    code: 500,
                };
            } /*finally {
              // playSound.playSound('caja')
              console.log('poniendo busy a: ', true)
              this.setBusy({busy: true})
            }*/
            console.log('imprimo');
            // Imprimo ticket
            this.tryPrint(tempTicket);
            // envío notificaciones
            const data = {
                clientName: this.tempSaleTicket.user.client,
                ticket: ticketToSend,
            };
            if (this.tempSaleTicket.stretch.type === 'event') {
                // data['type'] = 'event'
                // data['emails'] = this.tempSaleTicket.stretch.emails
            }
            console.log('data: ', data);
            if (isPaymentlink) {
                const dateExpiration = new Date();
                const totalExpiration = dateExpiration.getTime() + tempTicket.timeExpiration;
                dateExpiration.setTime(totalExpiration);
                // @ts-ignore
                const dataPaymentlink = {
                    businessName: tempTicket.businessUnitName,
                    // @ts-ignore
                    urlLogo: tempTicket.urlImage,
                    primaryColor: '#4f46e5',
                    clientName: tempTicket.user.client,
                    stretchName: tempTicket.getStretch().name,
                    datebook: tempTicket.datebook.toLocaleString(),
                    lines: tempTicket.lines.map(line => {
                        return {
                            category: line.stretchPrice.passengerCategory.name,
                            quantity: line.quantity
                        };
                    }),
                    totalFormatted: `${tempTicket.total} ${tempTicket.money}`,
                    dateExpiration: dateExpiration.toLocaleString(),
                    checkoutUrl: `/${response.payload.token}`
                };
                console.log('dataPaymentlink: ', dataPaymentlink);
                // await this.sendPaymentLinkEmails(data)
                this.setBusy({ busy: false });
                return { code: 200, numero: ticketToSend.numero };
            }
            yield this.sendEmails(data);
            this.setBusy({ busy: false });
            return { code: 200, numero: ticketToSend.numero };
        });
    }
    tryPrint(tempTicket) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setBusy({ busy: true });
                yield this.print();
                if (this.printerError !== '') {
                    this.onRejected('');
                }
                else {
                    this.setBusy({ busy: false });
                    tempTicket.reset();
                }
            }
            catch (e) {
                this.onRejected(e);
            }
        });
    }
    onRejected(reason) {
        // console.log('onrejected', reason)
        /*Alert.alert('ERROR', 'Parece que hay un problema con la impresora',
          [{
            text: 'Imprimir ticket', onPress: () => {
              this.printerError = ''
              return this.tryPrint(this.tempSaleTicket)
                .then(value => {
                  if (this.printerError !== '') {
                    this.onRejected('')
                  } else {
                    this.printerError = ''
                    this.setBusy({busy: false})
                    this.tempSaleTicket.reset()
                  }
                })
                .catch(reason1 => {
                  this.onRejected(reason1)
                })
            }
          }, {
            text: 'Continuar', style: 'cancel', onPress: () => {
              this.printerError = ''
              this.setBusy({busy: false})
              this.tempSaleTicket.reset()
            }
          }],
          {cancelable: false})*/
    }
    /*private sendTicket() {
      api.post('tickets', this.tempSaleTicket.toJSON())
        .then(response => {
          // console.log('response', response)
        })
    }*/
    ticketsCloseCaja(tickets) {
        const id = this.store.users.user.id;
        return api.post(`tickets/caja/user/${id}?eager=[lines,operationLine, stretch,lines.passengerCategory]`, { tickets });
    }
}
__decorate([
    observable
], TempTicketStore.prototype, "tempSaleTicket", void 0);
__decorate([
    observable
], TempTicketStore.prototype, "tempSalePacket", void 0);
__decorate([
    observable
], TempTicketStore.prototype, "_busy", void 0);
__decorate([
    observable
], TempTicketStore.prototype, "typeTicketSelected", void 0);
__decorate([
    action
], TempTicketStore.prototype, "init", void 0);
__decorate([
    action
], TempTicketStore.prototype, "setTypeTicket", void 0);
__decorate([
    action
], TempTicketStore.prototype, "setBusy", null);
__decorate([
    computed
], TempTicketStore.prototype, "busy", null);
__decorate([
    action
], TempTicketStore.prototype, "createTicket", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/TempSale/TempTicketStore.ts
// module id = 355
// module chunks = 0